"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default() {
  return function (Component) {
    return function (props) {
      var userProps = (0, _omit2["default"])(props, ['onValidChange', 'initialValues']);
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        onValidChange: props.onValidChange,
        initialValues: props.initialValues,
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(Component, userProps));
        }
      });
    };
  };
};